mutation checkWithdrawUnlock($user_id: String, $resend: Boolean) {
    checkWithdrawUnlock(user_id: $user_id, resend: $resend)
}
